import Breadcrumb from "components/Common/Breadcrumb"
import DeleteModal from "components/Common/DeleteModal"
import DynamicTable from "components/Common/DynamicTable"
import {
  deleteCouponCode,
  getAllCouponCode,
} from "helpers/backendHelpers/couponCode"
import { SimpleStringValue } from "helpers/common_helper_functions"
import React, { useEffect, useMemo, useState } from "react"
import { Link } from "react-router-dom"
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  UncontrolledTooltip,
} from "reactstrap"

const CouponCode = props => {
  const [couponCode, setCouponCode] = useState([])
  const [loading, setLoading] = useState(false)
  const [deleteCoupon, setDeleteCoupon] = useState({})
  const [deleteModal, setDeleteModal] = useState(false)
  const [save, setSave] = useState(false)
  const [pageIndex, setPageIndex] = useState(0)
  const [pageSize, setPageSize] = useState(100)
  const [totalRecords, setTotalRecords] = useState(0)
  const [search, setSearch] = useState("")

  useEffect(() => {
    fetchAllCouponCode()
  }, [pageIndex, pageSize, save])

  //* fetch all coupon code
  const fetchAllCouponCode = async (searchValue = search) => {
    try {
      setLoading(true)
      const response = await getAllCouponCode(pageIndex + 1, pageSize, searchValue)
      setCouponCode(response?.payload?.data || [])
      setTotalRecords(Number(response?.payload?.count || 0))
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  //* handle add button click
  const handleAddButtonClick = () => {
    props.history.push("/coupon-code/add")
  }

  //* open delete modal
  const onClickDelete = Data => {
    setDeleteCoupon(Data)
    setDeleteModal(true)
  }

  //* handle Delete coupon code
  const handleDeleteCouponCode = async () => {
    try {
      await deleteCouponCode(deleteCoupon._id)
      setSave(!save)
      setDeleteModal(false)
    } catch (error) { }
  }

  const columns = useMemo(
    () => [
      {
        Header: "Coupon Code",
        accessor: "couponCode",
        filterable: true,
        Cell: cellProps => {
          return <SimpleStringValue {...cellProps} />
        },
      },
      {
        Header: "Created Date",
        accessor: "createdAt",
        filterable: true,
        Cell: cellProps => {
          const data = cellProps.row.original
          return <span>{data?.createdAt ? new Date(data.createdAt).toLocaleDateString('en-GB') : "-"}</span>
        },
      },
      {
        Header: "Discount Type",
        accessor: "discountType",
        filterable: true,
        Cell: cellProps => {
          return <SimpleStringValue {...cellProps} />
        },
      },
      {
        Header: "Discount Value",
        accessor: "discountValue",
        filterable: true,
        Cell: cellProps => {
          return <SimpleStringValue {...cellProps} />
        },
      },
      {
        Header: "Expiration Date",
        accessor: "expirationDate",
        filterable: true,
        Cell: cellProps => {
          const data = cellProps.row.original
          return (
            <span>{data?.expirationDate ? new Date(data?.expirationDate).toLocaleDateString('en-GB') : "-"}</span>
          )
        },
      },
      {
        Header: "Description",
        accessor: "description",
        filterable: true,
        Cell: cellProps => {
          return <SimpleStringValue {...cellProps} />
        },
      },

      {
        Header: "Action",
        accessor: "action",
        disableFilters: true,
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3">
              <Link
                to="#"
                className="text-primary"
                onClick={() => {
                  props.history.push(
                    "/coupon-code/view/" + cellProps.row.original._id
                  )
                }}
              >
                <i className="mdi mdi-eye font-size-18" id="viewtooltip" />
                <UncontrolledTooltip placement="top" target="viewtooltip">
                  View
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-success"
                onClick={() => {
                  props.history.push(
                    "/coupon-code/edit/" + cellProps.row.original._id
                  )
                }}
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Edit
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-danger"
                onClick={() => {
                  onClickDelete(cellProps.row.original)
                }}
              >
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">
                  Delete
                </UncontrolledTooltip>
              </Link>
            </div>
          )
        },
      },
    ],
    []
  )

  //meta title
  document.title = "Coupon Code | React Admin & CouponCode Template"

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteCouponCode}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Coupon Code" />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <DynamicTable
                    columns={columns}
                    data={couponCode}
                    isLoading={loading}
                    pageIndex={pageIndex}
                    pageSize={pageSize}
                    pageCount={Math.ceil(totalRecords / pageSize)}
                    canPreviousPage={pageIndex > 0}
                    canNextPage={pageIndex < Math.ceil(totalRecords / pageSize) - 1}
                    gotoPage={setPageIndex}
                    previousPage={() => setPageIndex(pageIndex - 1)}
                    nextPage={() => setPageIndex(pageIndex + 1)}
                    setPageSize={(size) => {
                      setPageIndex(0)
                      setPageSize(size)
                    }}
                    state={{ pageIndex, pageSize }}
                    addButtonLabel="Add Coupon Code"
                    handleAddButtonClick={handleAddButtonClick}
                    totalRecords={totalRecords}
                    search={search}
                    handleSearchChange={(event) => setSearch(event.target.value)}
                    handleSearchClick={() => {
                      if (pageIndex !== 0) setPageIndex(0)
                      else fetchAllCouponCode(search)
                    }}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default CouponCode
